// import API from "../../../app/api";

// export const getCheckoutProcess = async (checkoutId, data) => {
//   try {
//     const res = await API.put(
//       `/checkout/${checkoutId}/process`,
//       data
//     );

//     if (res.data?.success) {
//       return res.data.data;
//     }

//     return null;
//   } catch (error) {
//     console.error("Checkout Process Error:", error);
//     return null;
//   }
// };

import API from "../../../app/api";

export const getCheckoutProcess = async (checkoutId, payload) => {
  try {
    const response = await API.put(
      `/checkout/${checkoutId}/process`,
      payload
    );

    console.log("API Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    return null;
  }
};